import { type FunctionComponent } from "react";

import stackIcon from "images/Common/stack.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedStack: FunctionComponent<IBTIconProps> = (baseProps) => {
    return <img alt="" src={stackIcon} style={baseProps.style} className={baseProps.className} />;
};
